import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    id: String,
    svg: String,
    png: String,
  };

  download(event) {
    const format = event.currentTarget.dataset.format;
    const qrId = this.idValue;
    let dataUrl, fileName;

    if (format === 'svg') {
      dataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
        this.svgValue
      )}`;
      fileName = `qr-code-${qrId}.svg`;
    } else if (format === 'png') {
      dataUrl = this.pngValue;
      fileName = `qr-code-${qrId}.png`;
    } else if (format === 'jpeg') {
      // For JPEG, we'll convert the PNG to JPEG client-side
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        const jpegDataUrl = canvas.toDataURL('image/jpeg', 0.9);

        const downloadLink = document.createElement('a');
        downloadLink.href = jpegDataUrl;
        downloadLink.download = `qr-code-${qrId}.jpg`;
        downloadLink.click();
      };
      img.src = this.pngValue;
      return;
    }

    const downloadLink = document.createElement('a');
    downloadLink.href = dataUrl;
    downloadLink.download = fileName;
    downloadLink.click();
  }
}
